import { render, staticRenderFns } from "./ResourceListItem.vue?vue&type=template&id=0cee5290&scoped=true&"
import script from "./ResourceListItem.vue?vue&type=script&lang=js&"
export * from "./ResourceListItem.vue?vue&type=script&lang=js&"
import style0 from "./ResourceListItem.vue?vue&type=style&index=0&id=0cee5290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cee5290",
  null
  
)

export default component.exports